const baseURL = 'https://megaventas.store/';

export default baseURL;
